import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo'
import { Col, Form, Row } from 'react-bootstrap';
import ShowVideo from '../shared/ShowVideo';
import TeacherCombo from '../combos/TeacherCombo';
import FaDate from '../shared/FaDate';


export default function EmployeeInMandatoryHours(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showEmployeeState, setShowEmployeeState] = useState(false);
  const [loadingEmployeeState, setLoadingEmployeeState] = useState(false);
  const [employeeItems, setEmployeeItems] = useState([]);
  const [inMandatoriesByMonth, setInMandatoriesByMonth] = useState([]);
  //
  const [mandatoryHours, setMandatoryHours] = useState(0);
  const [inMandatoryHours, setInMandatoryHours] = useState(0);
  const [hours, setHours] = useState(0);
  const [date, setDate] = useState(0);
  const [comment, setComment] = useState(0);
  const [newDate, setNewDate] = useState(0);
  const [nowDate, setNowDate] = useState(0);
  const [hoursSum, setHoursSum] = useState(0);
  const [daysSum, setDaysSum] = useState(0);

  const [teacher, setTeacher] = useState({});
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);


  const [currentItem, setCurrentItem] = useState(null);


  useEffect(() => {

  }, []);

  const addNewItem = function () {
    setCurrentItem(null);
    setDate(nowDate);
    setNewDate(nowDate);
    setComment("");
    setEditFormVisible(true);
  }
  const onRowDeleteClick = function (row) {
    setDate(row.date);
    setConfirmDeleteVisible(true);
  }

  const closeEditDialog = function () {
    setEditFormVisible(false);
  }
  const deleteItem = function () {
    setDeleting(true);
    var params = { login: util.getTrustedUser(), employeeId: teacher.id, date:date };
    var url = config.Server + `/school/employee/in-mandatory/delete-hour`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;

          setEmployeeItems(response.workTime.inMandatories);
          setInMandatoriesByMonth(response.inMandatoriesByMonth);
          setMandatoryHours(response.workTime.mandatoryHours);
          setInMandatoryHours(response.workTime.inMandatoryHours);
          setNowDate(response.nowDate);
          setHoursSum(response.inMandatoryHoursSum);
          setDaysSum(response.inMandatoryDaysSum);

          setDeleting(false);
          setConfirmDeleteVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setDeleting(false);
        }
      })
      .catch(error => {
        setDeleting(false);
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
      });
  }
  const onDeleteConfirm_Accept = function () {
    deleteItem();
  }
  const onDeleteConfirm_Reject = function () {
    if (deleting) return;
    setConfirmDeleteVisible(false);
  }

  const checkDataEntry = function () {
    if(newDate<=0){
      setErorVisible(true);
      setErrorMessage("تاریخ را مشخص نمائید");
      return false;
    }
    if(hours<=0){
      setErorVisible(true);
      setErrorMessage("تعداد ساعت را مشخص نمائید");
      return false;
    }
    return true;
  }
  const saveItem = function () {
    if (!checkDataEntry()) return;

    setSaving(true);
    var params = { login: util.getTrustedUser(), employeeId: teacher.id, hours: hours, date: newDate, comment: comment };
    var url = config.Server + `/school/employee/in-mandatory/add-hour`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          
          setEmployeeItems(response.workTime.inMandatories);
          setInMandatoriesByMonth(response.inMandatoriesByMonth);
          setMandatoryHours(response.workTime.mandatoryHours);
          setInMandatoryHours(response.workTime.inMandatoryHours);
          setNowDate(response.nowDate);
          setHoursSum(response.inMandatoryHoursSum);
          setDaysSum(response.inMandatoryDaysSum);


          setSaving(false);
          setEditFormVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }
  const editDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { closeEditDialog() }} saving={saving} />
    )
  }
  const onInputChange = function (e, n) {
    var val = '';
    val = (e.target && e.target.value) || '';
    if (n === "comment") setComment(val);
  }


  const setRowActions = function (row) {
    return (
      <Row className="justify-content-md-center" style={{}}>
        <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
      </Row>
    );
  }

  const onComboChange = function (name, value) {
    if(name == "teacher"){
      setTeacher(value);
      setShowEmployeeState(false);
      setEmployeeItems([]);
      console.log("teacher->", value)
    }
  }
  const btnShowEmployeeState_Click = function(){
    if(!teacher) return;
    if(teacher == null) return;
    if(!teacher.id)return;
    if(teacher.id == "")return;

    setLoadingEmployeeState(true);
    var params = { login: util.getTrustedUser(), employeeId: teacher.id };
    var url = config.Server + `/school/employee/work-time/get`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);

          setEmployeeItems(response.workTime.inMandatories);
          setInMandatoriesByMonth(response.inMandatoriesByMonth);
          setMandatoryHours(response.workTime.mandatoryHours);
          setInMandatoryHours(response.workTime.inMandatoryHours);
          setNowDate(response.nowDate);
          setHoursSum(response.inMandatoryHoursSum);
          setDaysSum(response.inMandatoryDaysSum);


          setLoadingEmployeeState(false);
          setShowEmployeeState(true);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setLoadingEmployeeState(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setLoadingEmployeeState(false);
      });

    
  }
  const saveEmployeeWorkHoursInWeek = function(){
    setSaving(true);
    var params = { login: util.getTrustedUser(), employeeId: teacher.id, mandatoryHours: mandatoryHours, inMandatoryHours: inMandatoryHours };
    var url = config.Server + `/school/employee/work-time/save`;
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          
          setEmployeeItems(response.workTime.inMandatories);
          setInMandatoriesByMonth(response.inMandatoriesByMonth);
          setMandatoryHours(response.workTime.mandatoryHours);
          setInMandatoryHours(response.workTime.inMandatoryHours);
          setNowDate(response.nowDate);
          setHoursSum(response.inMandatoryHoursSum);
          setDaysSum(response.inMandatoryDaysSum);


          setSaving(false);
          setEditFormVisible(false);
        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });

  }
  return (
    (redirectUrl != "")
        ?
        <Navigate to={redirectUrl} replace={false}  />
    :
    <>
      <ShowVideo videoId="school_create_classes" top={65} md={6} />
      <div className="card" style={{marginBottom:"20px", padding:"10px"}}>
          <Row>
            <Col md={4}>
              <TeacherCombo returnFullItem={true} value={teacher} onChange={(val) => onComboChange('teacher', val)} caption="کارمند" />
            </Col>
            <Col md={3} style={{paddingTop:"30px", direction:"ltr", textAlign:"right"}}>
              <Button label="مشاهده وضعیت" icon="pi pi-search" onClick={() => btnShowEmployeeState_Click()} severity="success" iconPos="right" loading={loadingEmployeeState} />
            </Col>
            <Col md={3} style={{paddingTop:"30px", direction:"ltr", textAlign:"right"}}>
              <Button label="گزارش ماهانه همه همکاران" icon="pi pi-search" onClick={() => setRedirectUrl("/school/employee/in-mandatory-hours/report")} severity="primary" iconPos="right" />
            </Col>
          </Row>
      </div>
      {
        showEmployeeState?
        <>
        <div className="card">
              <div className="page-caption">لیست ساعت های غیر موظف</div>

              <Row style={{}}>
                <Col md={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                    <Button label="افزودن به لیست" icon="pi pi-plus" onClick={() => addNewItem()} severity="secondary" iconPos="right" />
                  </div>
                </Col>
              </Row>
        
              <DataTable value={employeeItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows 
                dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="date" body={(row) => util.SeperateDate(row.date)} header={"تاریخ"} sortable className="list-cell-text-align"></Column>
                <Column field="hours" header={"ساعت"} sortable className="list-cell-text-align"></Column>
                <Column field="comment" header={"شرح"} sortable className="list-cell-text-align"></Column>
                <Column body={(row) => setRowActions(row)} exportable={false} style={{ width: "100px" }}></Column>
              </DataTable>
        </div>

        <div className="card" style={{marginTop:"20px"}}>
              <div className="page-caption">لیست ساعات غیر موظف به تقکیک ماه</div>


              <DataTable value={inMandatoriesByMonth} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows 
                dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"}  sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="monthName" header={"ماه"} sortable  headerStyle={{ width: '80px' }} className="list-cell-text-align"></Column>
                <Column field="hours" header={"ساعت"} sortable  headerStyle={{ width: '80px' }}className="list-cell-text-align"></Column>
                <Column field="days" header={"روز"} sortable  headerStyle={{ width: '80px' }}className="list-cell-text-align"></Column>
                <Column  body={(row) => ""} header={"-"} sortable className="list-cell-text-align"></Column>
              </DataTable>

              <div style={{margin:"10px 0px 20px 0px"}}>
                <table>
                  <tbody>
                    <tr>
                      <td style={{width:"100px"}}>&nbsp;</td>
                      <td style={{textAlign:"left", padding:"5px", width:"90px"}}>جمع ساعت:</td>
                      <td style={{textAlign:"right", padding:"5px", width:"90px", backgroundColor:"gray", color:"white"}}>{hoursSum}</td>
                      <td style={{width:"50px"}}></td>
                      <td style={{textAlign:"left", padding:"5px", width:"90px"}}>جمع روز:</td>
                      <td style={{textAlign:"right", padding:"5px", width:"90px", backgroundColor:"gray", color:"white"}}>{daysSum}</td>
                      <td style={{}}>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>
        
        </div>

        {
          false?
        <div className="card" style={{marginTop:"20px"}}>
              <div className="page-caption">ثبت میزان ساعت کاری</div>


              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col md={3}>
                  تعداد ساعت موظف در هفته
                  <br/>
                  <InputNumber inputId="integeronly" value={mandatoryHours} onValueChange={(e) => setMandatoryHours(e.value)} useGrouping={true}  maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
                </Col>
                <Col md={3}>
                  تعداد ساعت غیرموظف در هفته
                  <br/>
                  <InputNumber inputId="integeronly" value={inMandatoryHours} onValueChange={(e) => setInMandatoryHours(e.value)} useGrouping={true}  maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
                </Col>
              </Row>

              <Row style={{}}>
                <Col md={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", margin: "10px" }}>
                    <Button label="ثبت ساعت کاری" icon="pi pi-check" onClick={() => saveEmployeeWorkHoursInWeek()} severity="success" iconPos="right" loading={saving} />
                  </div>
                </Col>
              </Row>
        
        </div>
        :
        <></>
        }
        </>
        :
        <></>
      }

      {
        editFormVisible ?
          <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="ثبت ساعت غیر موظف" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td colSpan={2}>
                      تاریخ:
                      <br/>
                      <FaDate value={date} onChange={(val)=>setNewDate(val)} />
                  </td>
                </tr>
                <tr><td colSpan={2}>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputNumber inputId="integeronly" value={hours} onValueChange={(e) => setHours(e.value)} useGrouping={true}  maxLength={2} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}}/>
                      <label htmlFor="username">تعداد ساعت</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                  <td style={{ padding: "1px" }}>
                    <FloatLabel>
                      <InputText value={comment} onChange={(e) => { onInputChange(e, "comment") }} id="comment" keyfilter="" maxLength={200} className="p-inputtext-lg" style={{ width: "100%", textAlign: "center" }} />
                      <label htmlFor="comment">شرح</label>
                    </FloatLabel>
                  </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
              </tbody>
            </table>

          </Dialog>
          :
          <></>
      }
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </>
  );
}
